import React from "react";
import "./Qiymat.css";
import Mavzu from "./Mavzu";
import Video from "./Video";

function Yonalish({ kurslar, mavzu, kurs_id, activeMavzu, setActiveMavzu, filterType, userData, refreshUserData, handleLogout, isSearchMode }) {
  // If no course selected (e.g. searching but no results), show blurred dummy content
  // Otherwise, we show the actual course found by Qiymat (usually first in results or first in category)
  if (!kurslar || !kurslar.id) {
    const dummyCourse = {
      id: 9999,
      nomi: "Tanlanmagan Kurs",
      izoh: "Kurs haqida umumiy ma'lumot shu yerda bo'ladi...",
      rasm: "https://via.placeholder.com/300x200?text=Kurs",
      narx: 0,
      video: "",
      sotib_olingan: false
    };

    return (
      <div className="yonalish-quti custom-blurred-wrapper">
        <div style={{ position: 'relative' }}>
          <div className="blur-target">
            <Mavzu
              kurslar={dummyCourse}
              mavzu={[]}
              kurs_id={dummyCourse.id}
              activeMavzu={0}
              setActiveMavzu={() => { }}
            />
          </div>
        </div>

        {filterType !== "mobile" && filterType !== "algoritm" && (
          <div style={{ position: 'relative' }}>
            <div className="blur-target">
              <Video
                kurs={dummyCourse}
                userData={userData || {}}
                refreshUserData={() => { }}
                handleLogout={() => { }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  const content = (
    <>
      <Mavzu
        kurslar={kurslar}
        mavzu={mavzu}
        kurs_id={kurs_id}
        activeMavzu={activeMavzu}
        setActiveMavzu={setActiveMavzu}
      />
      {filterType !== "mobile" && filterType !== "algoritm" && (
        <Video
          kurs={kurslar}
          userData={userData}
          refreshUserData={refreshUserData}
          handleLogout={handleLogout}
        />
      )}
    </>
  );

  return (
    <div className={`yonalish-quti ${isSearchMode ? "custom-blurred-wrapper" : ""}`}>
      {isSearchMode ? (
        <div style={{ display: 'contents' }}>
          <div className="blur-target" style={{ gridColumn: 'span 2', display: 'grid', gridTemplateColumns: 'subgrid', columnGap: 'inherit' }}>
            {content}
          </div>
        </div>
      ) : (
        content
      )}
    </div>
  );
}

export default Yonalish;
